export enum UserAreaMappingTypeEnum {
  ORGANIZATION = "ORGANIZATION",
  MODULE = "MODULE",
  LOCATION = "LOCATION",
  COMPONENT_CLASS = "COMPONENT_CLASS",
  OBJECT = "OBJECT"
}
